import React from 'react';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import './Analyst.css';
import AnalystImage from './analyst.png';

const Analyst = () => {
  return (
    <div className="data-patent-page">
      <Navbar />
      <main className="data-patent-hero">
          <h1>Cnyda Dynamics Patents Division</h1>
        <section className="data-patent-body">
          <h2 className="data-patent-sub-heading">AI Analyst Patent:</h2>
          
          <div className="data-patent-description">
            <p>
              Analyst AI represents a paradigm shift in decision-making, powered by our patented Cognitive Brain architecture. This platform is engineered to transcend the limitations of conventional analytics by seamlessly synthesizing structured and unstructured data into coherent, actionable intelligence. By integrating high-level reasoning with highly automated, agentic workflows, Analyst AI provides a comprehensive suite of capabilities—ranging from sophisticated statistical modeling and trend forecasting to advanced natural language intelligence—all delivered with unprecedented velocity and precision. It effectively collapses the traditional distance between raw data and strategic clarity, ensuring that organizations can navigate increasingly complex environments with a reliable, data-centric foundation.
            </p>

            <img 
              src={AnalystImage} 
              alt="Data Analytics Visualization" 
              className="data-patent-media"
            />

            <p>
              Moving far beyond the scope of legacy business intelligence tools, Analyst AI operates as a sophisticated, autonomous analytical partner. It is designed to autonomously manage complex machine learning lifecycles, from the intricate processing of large-scale, heterogeneous datasets to the development of robust predictive models and the generation of nuanced, strategic recommendations. The platform is architected to remain dynamic, continuously recalibrating its focus to align with shifting user objectives and evolving data landscapes. By streamlining these critical workflows, Analyst AI accelerates the pace of discovery, drives operational excellence, and unlocks profound, latent value within enterprise data assets across a diverse range of industries.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Analyst;